exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lead-lockup[data-v-6402fb02] {\n  margin-bottom: var(--size-base);\n  color: var(--gray-800);\n}\n.lead-lockup__lead__container[data-v-6402fb02] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.lead-lockup__lead[data-v-6402fb02] {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n}\n.lead-lockup__context[data-v-6402fb02] {\n  font-size: var(--size-base);\n  color: var(--gray-600);\n}\n.lead-lockup__context > *[data-v-6402fb02] {\n  margin: 0;\n}", ""]);

// exports
